import { defineStore } from 'pinia';
import { configRequest } from 'config-request';
import { getRequestIns } from '../requestIns';
export const useOptionDetailStore = defineStore('option-detail', {
    actions: {
        /**
         * 查询option弹窗图片文案
         * @param params
         */
        async getOptionDetail(params, otherParams) {
            try {
                const result = await configRequest(getRequestIns()).optionDetail(params, otherParams);
                return result?.data ?? null;
            }
            catch (error) {
                throw error;
            }
        },
    },
});
